export default () => ({
  open: false,
  active: '',

  init() {
    const pathname = document.location.pathname;
    const current = this.$el.querySelector('a[href^="' + pathname + '"]');
    this.active = current.innerText;
    document.addEventListener('click', (event) => {
      if(!this.$el.contains(event.target)) this.open = false;
    });
  }
})
